import { MaterialGradeType } from "../types";

export const materialWordingMap: Record<MaterialGradeType, string> = {
  STEEL_PRE_LACQUERED: "Acier Prélaqué",
  STEEL_COLD_ROLLED_CORTEN: "Acier Corten laminé à froid",
  STEEL_HOT_ROLLED_CORTEN: "Acier Corten Laminé à chaud",
  STEEL: "Acier",
  GALVANIZED_STEEL: "Acier galvanisé",
  ALUMINIUM: "Aluminium",
  ZINC: "Zinc naturel",
  BRASS: "Laiton",
  COPPER: "Cuivre",
  STAINLESS_STEEL: "Acier inoxydable",
  BRONZE: "Bronze",
  PLASTIC: "Plastique",
  CAST_IRON: "Fonte",
  RUBBER: "Caoutchouc",
  MAGNESIUM: "Magnésium",
  TITANIUM: "Titane",
  COMPOSITE: "Composite",
  WOOD: "Bois",
  INCONEL: "Inconel",
  OTHER: "Autre",
};
